export const arc4 = '4px';
export const arc8 = '8px';
export const arc12 = '12px';
export const arc20 = '20px';
export const arc99999 = '99999px';
export const circle = '50%';